import React, { Component } from 'react';
//import Parser from 'html-react-parser';
//import { NavLink } from "react-router-dom";
//import Select2 from 'react-select2-wrapper';
//import $ from 'jquery';
import UnAuthorised from "./UnAuthorised";
import { Alert } from 'rsuite';
//import { Textbox } from 'react-inputs-validation';
import { LOGIN_TYPE_ADMIN, SERVICE41_TEXT, GetSettingURL } from './helper/Constants';
import { reactLocalStorage } from "reactjs-localstorage";
import Apihelpers from "./helper/ApiHelper";
import Header from "./include/Header";


export default class BUHeadBillingReport extends Component {
  constructor() {
    super();
    this.state = {
      loader: false,
      listData:[],
      filters:{
        apiType:'all',
        startDate: '',
        endDate: '',
        totalCount:0,
        businessUnit:'all',
        reportType:'bu-head-report',
        rawapi:'ALL',
        source:'all'
      },
      fileName:'',
      basePath: Apihelpers.getBaseUrl(),
      buUnites:[]
    }
  }
  componentDidMount() {
    //this.loadListData();
    this.get_Data_Of_Setting();
    this.assignDefaultDateInFilter();
  }
  assignDefaultDateInFilter = () => {
    let newDate = new Date();
    let date = ("0" + newDate.getDate()).slice(-2);
    let month = ("0" + (newDate.getMonth() + 1)).slice(-2);
    let year = newDate.getFullYear();
    this.setState({
      listData:[],
      fileName:'',
      filters: {
        apiType:'all',
        totalCount:0,
        businessUnit:'all',
        startDate: year+'-'+month+'-01', 
        endDate: year+'-'+month+'-'+date,
        reportType:'bu-head-report',
        rawapi:'ALL',
        source:'all'
      }
    })
  }


  get_Data_Of_Setting = () => {
    Apihelpers.getdataresponse(GetSettingURL).then(res => {
      var data = res.data.data;
      console.log('data',data);
      this.setState({
        buUnites:data.bbuser_business_unit_options || []
      });
    });
  }


  loadListData() {
    let startD = this.state.filters.startDate;
    let endD = this.state.filters.endDate;
    let dayDiff = new Date(endD) - new Date(startD);
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    //console.log('dayDiff',dayDiff);
    if (dayDiff > 31 || dayDiff < 0) {
      Alert.error("Please select date range maximum 31 days and minimume 1 day");
      return;
    }
    console.log("this.state.filters.source------>",this.state.filters.source)
    let dataObj = {
        startDate: this.state.filters.startDate,
        endDate: this.state.filters.endDate,
        apitype: this.state.filters.apiType,
        businessUnit: this.state.filters.businessUnit,
        isClientReport: false,
        source: this.state.filters.source,
    };
    if(this.state.filters.reportType === 'client-report') {
      dataObj.isClientReport = true;
      dataObj['rawapi'] = this.state.filters.rawapi
    }
    this.setState({
        loader:true
    })
    Apihelpers.postdataresponse('bbuser/download-csv-report-of-bu-head-billing',dataObj).then(res => {
      if (res.data.status === 200) {
        this.setState({
          listData: res.data.data,
          fileName: res.data.fileName,
          filters:{...this.state.filters, totalCount:res.data.data.length},
          loader:false
        });
      } else {
        this.setState({
          listData: [],
          loader:false
        });
      }
    });
  }

  removeFilter = () => {
    this.assignDefaultDateInFilter();
  }

  buHeadBillngList = () => {
    return(
      <table className="table">
        <colgroup>
          <col style={{'background':'#ffffff'}}></col>
          <col style={{'background':'#ffffff'}}></col>
          <col style={{'background':'#ffffff'}}></col>
          <col style={{'background':'rgb(246 250 255)'}}></col>
          <col style={{'background':'#ffffff'}}></col>
          <col style={{'background':'rgb(246 250 255)'}}></col>
          <col style={{'background':'#ffffff'}}></col>
          <col style={{'background':'rgb(246 250 255)'}}></col>
          <col style={{'background':'#ffffff'}}></col>
          <col style={{'background':'rgb(246 250 255)'}}></col>
          <col style={{'background':'#ffffff'}}></col>
          <col style={{'background':'rgb(246 250 255)'}}></col>
          <col style={{'background':'#ffffff'}}></col>
        </colgroup>
        <thead>
          <tr>
            <th>Client Name</th>
            <th style={{'minWidth':'150px'}}>Client ID</th>
            <th style={{'minWidth':'150px'}}>Client Email</th>
            <th style={{'minWidth':'200px'}}>Total Prime Billable</th>
            <th style={{'minWidth':'770px'}}>
              <div className="thRowEle">
                <div className="thRow">Prime Success &nbsp; + &nbsp; Combo Prime Success</div>
                <div className="thRow">OwnDb &nbsp; + &nbsp; Gamma Success &nbsp; + &nbsp; Delta Success &nbsp; + &nbsp; Delta two Success &nbsp; + &nbsp; Delta Cache Success</div>
              </div>
            </th>
            <th style={{'minWidth':'200px'}}>Total Chalan Billable</th>
            <th style={{'minWidth':'500px'}}>
              <div className="thRowEle">
                <div className="thRow">Challan Success &nbsp; + &nbsp; Combo Challan Success</div>
                <div className="thRow">Challan OwnDb &nbsp; + &nbsp; Gamma &nbsp; + &nbsp; Delta &nbsp; + &nbsp; Delta Pro</div>
              </div>
            </th>
            <th style={{'minWidth':'200px'}}>Total Mobile Billable</th>
            <th style={{'minWidth':'400px'}}>
              <div className="thRowEle">
                <div className="thRow">Mobile Success</div>
                <div className="thRow">Mobile OwnDb &nbsp; + &nbsp; Delta</div>
              </div>
            </th>
            <th style={{'minWidth':'200px'}}>Total Pan Billable</th>
            <th style={{'minWidth':'400px'}}>
              <div className="thRowEle">
                <div className="thRow">Pan Success</div>
                <div className="thRow">Pan OwnDb &nbsp; + &nbsp; Gamma Success</div>
              </div>
            </th>
            <th style={{'minWidth':'200px'}}>Total Aadhaar Billable</th>
            <th style={{'minWidth':'400px'}}>
              <div className="thRowEle">
                <div className="thRow">Aadhaar Success</div>
                <div className="thRow">Aadhaar OwnDb &nbsp; + &nbsp; Delta Success</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
        {
        (this.state.listData.length > 0) ?
        this.state.listData.map((item)=>{
          return(
            <tr key={item.clientID}>
              <td>{item.clientName}</td>
              <td>{item.clientID}</td>
              <td>{item.clientEmail}</td>
              <td style={{'fontWeight':'bold','textAlign':'center'}}>{item.totalPrimeBillable}</td>
              <td>
                <div className="thRowEle">
                  <div className="thRow">{item.primeSuccess} + {item.comboPrimeSuccess}</div>
                  <div className="thRow">{item.database} + {item.gammaSucess} + {item.deltaSucess} + {item.deltatwoSucess} + {item.deltaCacheSucess}</div>
                </div>
              </td>
              <td style={{'fontWeight':'bold','textAlign':'center'}}>{item.totalChalanBillable}</td>
              <td>
                <div className="thRowEle">
                  <div className="thRow">{item.challanSuccess} + {item.comboChallanSucess}</div>
                  <div className="thRow">{item.challanOwnDb} + {item.gamma} + {item.delta} + {item.deltaPro}</div>
                </div>
              </td>
              <td style={{'fontWeight':'bold','textAlign':'center'}}>{item.totalMobileBillable}</td>
              <td>
                <div className="thRowEle">
                  <div className="thRow">{item.totalMobileBillable}</div>
                  <div className="thRow">{item.mobileOwndbSucess} + {item.mobileDeltaSucess}</div>
                </div>
              </td>
              <td style={{'fontWeight':'bold','textAlign':'center'}}>{item.totalPanFetchBillable}</td>
              <td>
                <div className="thRowEle">
                  <div className="thRow">{item.totalPanFetchBillable}</div>
                  <div className="thRow">{item.PanFetchOwndbSucess} + {item.PanFetchGammaSucess}</div>
                </div>
              </td>
              <td style={{'fontWeight':'bold','textAlign':'center'}}>{item.totalAadhaarFetchBillable}</td>
              <td>
                <div className="thRowEle">
                  <div className="thRow">{item.totalAadhaarFetchBillable}</div>
                  <div className="thRow">{item.AadhaarFetchOwndbSucess} + {item.AadhaarFetchDeltaSucess}</div>
                </div>
              </td>
            </tr>
          )
        })
        : 
        <tr>
          <td colSpan="5" align="center">
            <img src="/assets/images/data-not-found-img.png" /><br /><br />
            <b>Filter now for load data.</b>
          </td>
        </tr>
        }
        </tbody>
      </table>
    )
  }
  isClientReportList = () => {
    return(
      <table className="table">
        <thead>
          <tr>
            <th style={{'minWidth':'150px'}}>Client Name & Bussiness Unit</th>
            <th style={{'minWidth':'150px'}}>Client Email</th>
            {
              (this.state.listData.length > 0) ?
              <>
                {
                  (this.state.listData[0].RC_RTO_Collect !== undefined) ? 
                  <th style={{'textAlign':'center'}}>RTO(Collect)</th> : ''
                }
                {
                  (this.state.listData[0].RC_Source_Paid !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Source(Paid)</th> : ''
                }
                {
                  (this.state.listData[0].RC_Database !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Diff</th> : ''
                }
                {
                  (this.state.listData[0].RC_Total_Gamma !== undefined) ? 
                  <th style={{'textAlign':'center'}}>RC_Total_Gamma</th> : ''
                }
                {
                  (this.state.listData[0].RC_Total_Delta !== undefined) ? 
                  <th style={{'textAlign':'center'}}>RC_Total_Delta</th> : ''
                }
                {
                  (this.state.listData[0].RC_delta !== undefined) ? 
                  <th style={{'textAlign':'center'}}>RC_delta</th> : ''
                }
                {
                  (this.state.listData[0].RC_deltatwo !== undefined) ? 
                  <th style={{'textAlign':'center'}}>RC_deltatwo</th> : ''
                }
                {
                  (this.state.listData[0].RC_deltaCache !== undefined) ? 
                  <th style={{'textAlign':'center'}}>RC_deltaCache</th> : ''
                }
                {
                  (this.state.listData[0].Challan_RTO_Collect !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Challan_RTO_Collect</th> : ''
                }
                {
                  (this.state.listData[0].Challan_Source_Paid !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Challan_Source_Paid</th> : ''
                }
                {
                  (this.state.listData[0].Challan_Database !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Challan_Database</th> : ''
                }
                {
                  (this.state.listData[0].Challan_Total_Gamma !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Challan_Total_Gamma</th> : ''
                }
                {
                  (this.state.listData[0].Challan_Total_Delta !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Challan_Total_Delta</th> : ''
                }
                {
                  (this.state.listData[0].Challan_Delta !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Challan_Delta</th> : ''
                }
                {
                  (this.state.listData[0].Challan_DeltaPro !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Challan_DeltaPro</th> : ''
                }
                {
                  (this.state.listData[0].Mobile_RTO_Collect !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Mobile_RTO_Collect</th> : ''
                }
                {
                  (this.state.listData[0].Mobile_Source_Paid !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Mobile_Source_Paid</th> : ''
                }
                {
                  (this.state.listData[0].Mobile_Database !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Mobile_Database</th> : ''
                }
                {
                  (this.state.listData[0].Mobile_Total_Delta !== undefined) ? 
                  <th style={{'textAlign':'center'}}>Mobile_Total_Delta</th> : ''
                }
                {
                  (this.state.listData[0].PanFetch_RTO_Collect !== undefined) ? 
                  <th style={{'textAlign':'center'}}>PanFetch_RTO_Collect</th> : ''
                }
                {
                  (this.state.listData[0].PanFetch_Source_Paid !== undefined) ? 
                  <th style={{'textAlign':'center'}}>PanFetch_Source_Paid</th> : ''
                }
                {
                  (this.state.listData[0].PanFetch_Database !== undefined) ? 
                  <th style={{'textAlign':'center'}}>PanFetch_Database</th> : ''
                }
                {
                  (this.state.listData[0].PanFetch_Total_Gamma !== undefined) ? 
                  <th style={{'textAlign':'center'}}>PanFetch_Total_Gamma</th> : ''
                }
                {
                  (this.state.listData[0].AadhaarFetch_RTO_Collect !== undefined) ? 
                  <th style={{'textAlign':'center'}}>AadhaarFetch_RTO_Collect</th> : ''
                }
                {
                  (this.state.listData[0].AadhaarFetch_Source_Paid !== undefined) ? 
                  <th style={{'textAlign':'center'}}>AadhaarFetch_Source_Paid</th> : ''
                }
                {
                  (this.state.listData[0].AadhaarFetch_Database !== undefined) ? 
                  <th style={{'textAlign':'center'}}>AadhaarFetch_Database</th> : ''
                }
                {
                  (this.state.listData[0].AadhaarFetch_Total_Delta !== undefined) ? 
                  <th style={{'textAlign':'center'}}>AadhaarFetch_Total_Delta</th> : ''
                }
              </>
              : <th>---</th>
            }
          </tr>
        </thead>
        <tbody>
        {
        (this.state.listData.length > 0) ?
        this.state.listData.map((item, index)=>{
          return(
            <tr key={index}>
              <td><strong>{item.clientName}</strong> <br /><span className="num">{item.bussinessUnit}</span></td>
              <td>{item.clientEmail}</td>
              {
                (this.state.listData[0].RC_RTO_Collect !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.RC_RTO_Collect}</td> : ''
              }
              {
                (this.state.listData[0].RC_Source_Paid !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.RC_Source_Paid}</td> : ''
              }
              {
                (this.state.listData[0].RC_Database !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.RC_Database}</td> : ''
              }
              {
                (this.state.listData[0].RC_Total_Gamma !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.RC_Total_Gamma}</td> : ''
              }
              {
                (this.state.listData[0].RC_Total_Delta !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.RC_Total_Delta}</td> : ''
              }
              {
                (this.state.listData[0].RC_delta !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.RC_delta}</td> : ''
              }
              {
                (this.state.listData[0].RC_deltatwo !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.RC_deltatwo}</td> : ''
              }
              {
                (this.state.listData[0].RC_deltaCache !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.RC_deltaCache}</td> : ''
              }
              {
                (this.state.listData[0].Challan_RTO_Collect !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Challan_RTO_Collect}</td> : ''
              }
              {
                (this.state.listData[0].Challan_Source_Paid !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Challan_Source_Paid}</td> : ''
              }
              {
                (this.state.listData[0].Challan_Database !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Challan_Database}</td> : ''
              }
              {
                (this.state.listData[0].Challan_Total_Gamma !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Challan_Total_Gamma}</td> : ''
              }
              {
                (this.state.listData[0].Challan_Total_Delta !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Challan_Total_Delta}</td> : ''
              }
              {
                (this.state.listData[0].Challan_Delta !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Challan_Delta}</td> : ''
              }
              {
                (this.state.listData[0].Challan_DeltaPro !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Challan_DeltaPro}</td> : ''
              }
              {
                (this.state.listData[0].Mobile_RTO_Collect !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Mobile_RTO_Collect}</td> : ''
              }
              {
                (this.state.listData[0].Mobile_Source_Paid !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Mobile_Source_Paid}</td> : ''
              }
              {
                (this.state.listData[0].Mobile_Database !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Mobile_Database}</td> : ''
              }
              {
                (this.state.listData[0].Mobile_Total_Delta !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.Mobile_Total_Delta}</td> : ''
              }
              {
                (this.state.listData[0].PanFetch_RTO_Collect !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.PanFetch_RTO_Collect}</td> : ''
              }
              {
                (this.state.listData[0].PanFetch_Source_Paid !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.PanFetch_Source_Paid}</td> : ''
              }
              {
                (this.state.listData[0].PanFetch_Database !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.PanFetch_Database}</td> : ''
              }
              {
                (this.state.listData[0].PanFetch_Total_Gamma !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.PanFetch_Total_Gamma}</td> : ''
              }
              {
                (this.state.listData[0].AadhaarFetch_RTO_Collect !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.AadhaarFetch_RTO_Collect}</td> : ''
              }
              {
                (this.state.listData[0].AadhaarFetch_Source_Paid !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.AadhaarFetch_Source_Paid}</td> : ''
              }
              {
                (this.state.listData[0].AadhaarFetch_Database !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.AadhaarFetch_Database}</td> : ''
              }
              {
                (this.state.listData[0].AadhaarFetch_Total_Delta !== undefined) ? 
                <td style={{'textAlign':'center'}}>{item.AadhaarFetch_Total_Delta}</td> : ''
              }
            </tr>
          )
        })
        : 
        <tr>
          <td colSpan="3" align="center">
            <img src="/assets/images/data-not-found-img.png" /><br /><br />
            <b>Filter now for load data.</b>
          </td>
        </tr>
        }
        </tbody>
      </table>
    )
  }

  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN || reactLocalStorage.get("is_have_buheadbilling_service") === SERVICE41_TEXT) {
      return (
        <div className="wrapper">
          <Header />
          <div className="container">
            <div className="clientListPage buHeadBillingPage" style={{minHeight:'calc(100vh - 130px)'}}>
              {
                //JSON.stringify(this.state.filters)
              }
              <div className="titleBg">
                <div className="row">
                  <div className="col">
                    <h3 className="title">BU Head Billing Report <span className="count">Total Records : {this.state.filters.totalCount}</span></h3>
                  </div>
                </div>
              </div>
              <div className="filterRow">
                <div className="form-group" style={{'display':'none'}}>
                  <select className="form-control" onChange={(e)=>{
                    this.setState({filters:{...this.state.filters, apiType:e.target.value}})
                  }} value={this.state.filters.apiType}>
                    <option value="all">All Types</option>
                    {/* <option value="0">freeRC </option> */}
                    <option value="2">Challan</option>
                    {/* <option value="3">ServiceHistory</option> */}
                    <option value="9">RCPrime</option>
                    <option value="10">RCExcel</option>
                    {/* <option value="14">UsedCarPricing</option> */}
                    <option value="15">RCPrimeReverse</option>
                    {/* <option value="16">RCPrimeReverseBasic</option> */}
                    {/* <option value="19">UsedCarPricingV2</option> */}
                    <option value="32">comboPrime</option>
                    <option value="33">comboChallan</option>
                    <option value="36">ChallanExcel</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="filterLabel">Report Type</label>
                  <select className="form-control" onChange={(e)=>{
                    this.setState({
                      listData:[],
                      fileName:'',
                      filters:{...this.state.filters, reportType:e.target.value, businessUnit:'all'}
                    })
                  }} value={this.state.filters.reportType}>
                    <option value="bu-head-report">BU Head Billing Report</option>
                    <option value="client-report">Client Report</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="filterLabel">Business Unit</label>
                  <select className="form-control" required="required" onChange={(e)=>{
                    this.setState({
                      filters: {...this.state.filters, businessUnit: e.target.value}
                    })
                  }} value={this.state.filters.businessUnit}>
                    <option value="all">All Units</option>
                    {
                      this.state.buUnites.map((it)=>{
                        return(
                          <option key={it} value={it}>{it}</option>
                        )
                      })
                    }
                  </select>
                </div>
                <div className="form-group" style={{'display':`${(this.state.filters.reportType === 'client-report') ? 'inline-block':'none'}`}}>
                  <label className="filterLabel">Raw API Type</label>
                  <select className="form-control" onChange={(e)=>{
                    this.setState({
                      listData:[],
                      fileName:'',
                      filters:{...this.state.filters, rawapi:e.target.value}
                    })
                  }} value={this.state.filters.rawapi}>
                    <option value="ALL">ALL</option>
                    <option value="RC">RC Report</option>
                    <option value="CHALLAN">Challan Report</option>
                    <option value="MOBILE">Mobile Report</option>
                    <option value="PANFETCH">PanFetch Report</option>
                    <option value="AADHAARFETCH">AadhaarFetch Report</option>
                  </select>
                </div>
                <div className="form-group" >
                  <label className="filterLabel">Source Type</label>
                  <select className="form-control" onChange={(e)=>{
                    this.setState({
                      listData:[],
                      fileName:'',
                      filters:{...this.state.filters, source:e.target.value}
                    })
                  }} value={this.state.filters.source}>
                    <option value="all">All</option>
                    <option value="database">Database</option>
                    <option value="gamma">Gamma</option>
                    <option value="delta">Delta</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="filterLabel">From Date</label>
                  <input type="date" min="2022-01-01" className="form-control" name="startDate" onChange={(e)=>{this.setState({
                    filters: {...this.state.filters, startDate: e.target.value}
                  })}} value={this.state.filters.startDate} />
                </div>
                <div className="form-group">
                  <label className="filterLabel">To Date</label>
                  <input type="date" min="2022-01-01" className="form-control" name="endDate" onChange={(e)=>{this.setState({
                    filters: {...this.state.filters, endDate: e.target.value}
                  })}} value={this.state.filters.endDate} />
                </div>

                <div className="form-group btnRow">
                  <button className="blueBtn" onClick={()=>{this.loadListData()}} type="button"><i className="fa fa-filter"></i></button>
                </div>
                <div className="form-group btnRow">
                  <button className="backBtn" onClick={()=>{this.removeFilter()}} type="button"><i className="fa fa-undo"></i></button>
                </div>
                {
                  (this.state.fileName !== '') ?
                  <div className="form-group downloadNow">
                    <button title={this.state.fileName} className="blueBtn" onClick={()=>{
                      //window.open(this.state.basePath+'export-report/'+this.state.fileName, '_blank').focus();
                      const link = document.createElement('a');
                      link.href = this.state.basePath + 'export-report/' + this.state.fileName;
                      link.setAttribute('download', this.state.fileName); // optional: triggers download
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
                    }} type="button">Download CSV</button>
                  </div>
                  :
                  ''
                }
              </div>
              <div className="billingReportList">
                {
                  (this.state.filters.reportType === 'bu-head-report') ?
                  this.buHeadBillngList()
                  :
                  this.isClientReportList()
                }
              </div>

            </div>
          </div>

          <div className="loader" style={(this.state.loader) ? {'display':'block'} : {'display':'none'}}>
            <div className="bg"></div>
            <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
          </div>
        </div>
      );
    }
    else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}

